module.exports = new __parcel__URL__("logo_arz.3b0e377d.jpg").toString();